export default "__VITE_ASSET__CWyj2SQU__"